import { AppsFlyerEvent } from './platforms/appsFlyer/type';
import { useGoogleAnalytics } from './platforms/google';
import { GoogleEvent } from './platforms/google/type';

import { useMetaAnalytics } from './platforms/meta';
import { MetaEvent } from './platforms/meta/types';
import { useAppsFlyer } from './platforms/appsFlyer';
export interface MediaTrackingPayload {
  google?: GoogleEvent;
  meta?: MetaEvent;
  appsFlyer?: AppsFlyerEvent;
}

export const useOmniAds = () => {
  const { trackGoogle } = useGoogleAnalytics();
  const { trackMeta } = useMetaAnalytics();
  const { trackAppsFlyer } = useAppsFlyer();

  const trackPlatforms = (platforms: MediaTrackingPayload): void => {
    if (platforms.google) {
      trackGoogle(platforms.google);
    }

    if (platforms.meta) {
      trackMeta(platforms.meta);
    }

    if (platforms?.appsFlyer) {
      trackAppsFlyer(platforms.appsFlyer);
    }
  };

  return {
    omniTracker: {
      all: trackPlatforms,
      google: trackGoogle,
      meta: trackMeta,
    },
  };
};
